export default __webpack_public_path__ + "static/3-c47a2089b1ed4c4a502208b1e3f1fa3b.png";